<div class="page-header-container" id="page-header-container" #pageHeaderContainerElement
    [ngStyle]="{'top.px': -pageHeaderContainerHeight}">
    <div *ngIf="(selectedStore$ | async)?.settings?.IMAGE; else templateNoHero" class="position-relative">
        <div class="hero backArrowColor" #heroHeader>
            <div *ngIf="shouldDisplaySiblingSelection()">
                <div class="position-absolute hightFix d-sm-none d-block cursor-pointer" (click)="OnGoBack($event)">
                    <i class="fa fa-arrow-left ml-3" [ngClass]="{'white-font': isDark}"></i>
                </div>
            </div>
            <img [src]="(selectedStore$ | async)?.settings?.IMAGE">
            <div *ngIf="poweredBy === 'Yes'" class="powered-by">
                Powered by <a target="_blank" href="{{commercialUrl}}" class="pointer">{{whiteLabelName}}</a>
            </div>
        </div>
        <div class="d-none d-sm-flex row m-0">
            <div [style.width]="backgroundMargin + 'px'" class="h-100" [style.background-color]="logoBackgrondColor">
            </div>
            <div class="h-100" style="width: 100px;"
                [ngStyle]="{background: 'linear-gradient(to right, ' + logoBackgrondColor + ' 0%, transparent 2500%)'}">
            </div>
            <div class="h-100" style="width: 40vw; max-width: 700px;"
                [ngStyle]="{background: 'linear-gradient(to right, ' + logoBackgrondColor + ' -4%, transparent 96%)'}">
            </div>
        </div>
        <div class="row m-0 align-items-center logo-container">
            <div class="position-absolute hightFix cursor-pointer d-none d-sm-block" (click)="OnGoBack($event)"
                *ngIf="shouldDisplaySiblingSelection()">
                <i class="fa fa-arrow-left m-auto" [ngClass]="{'font-white': isDark}"></i>
            </div>
            <img class="logo mt-sm-0" *ngIf="selectedStore?.settings?.LOGO && selectedStore?.settings?.IMAGE"
                [src]="(selectedStore$ | async)?.settings?.LOGO" [style.margin-top]="'-' + logoMargin + 'px'"
                crossorigin="anonymous">
            <span class="store-information mt-2 mt-sm-0">
                <div *ngIf="selectedStore && selectedStore.name" [ngClass]="{'font-white': isDark}"
                    class="pb-1 font-size-header font-weight-bold">
                    {{selectedStore.name}}
                </div>
                <div class="py-1 font-size-primary store-description" [ngClass]="{'font-white': isDark}">
                    {{selectedStore?.description}}</div>
                <div class="d-flex">
                    <div class="pt-1 pr-3 mb-2 d-flex align-items-center open-time space-nowrap font-size-primary font-weight-bold"
                        (click)="onOpenTimeModal($event,'aboutUs')" style="cursor: pointer;"
                        *ngIf="selectedStore?.phoneNumber?.length  > 8 || selectedStore?.settings?.STORE_WEBSITE_URL || selectedStore?.settings?.DISPLAY_ADDRESS || isSocialMediaHandlePresent() || isReviewMediaHandlePresent()">
                        <i class="material-icons pr-2" [ngClass]="{'font-white': isDark}">info_outline</i>
                        <span [ngClass]="{'font-white': isDark}">{{'public.store.catalog.aboutUs' | translate}}</span>
                    </div>
                    <div *ngIf="openTimeSchedule"
                        class="pt-1 mb-2 d-flex align-items-center open-time space-nowrap font-size-primary font-weight-bold"
                        (click)="onOpenTimeModal($event,'openTimes')" style="cursor: pointer;">
                        <i class="far fa-clock pr-2" [ngClass]="{'font-white': isDark}"></i>
                        <span [ngClass]="{'font-white': isDark}">{{'public.global.opentimelist' | translate}}</span>
                    </div>
                </div>
            </span>
        </div>
        <div class="customer-profile-panel">
            <app-customer-login-button />
            <app-profile-menu variant="avatar"/>
        </div>
        <app-store-catalog-language-selector [haveBackground]="true" (isLoadingStatus)="isLoadingEmitter($event)"
            class="theme-interface"></app-store-catalog-language-selector>
    </div>

    <ng-template #templateNoHero>
        <div class="store-info position-relative mx-auto" #noHeroHeader>
            <div class="py-4 pl-4 theme-light" [ngClass]="{'pt-5': shouldDisplaySiblingSelection()}">
                <div class="store-title d-flex flex-column m-1">
                    <div class="position-absolute hightFix cursor-pointer" (click)="OnGoBack($event)"
                        *ngIf="shouldDisplaySiblingSelection()">
                        <i class="fa fa-arrow-left m-auto theme-light"></i>
                    </div>
                    <div class="font-size-header font-weight-bold pb-1">{{(selectedStore$ | async)?.name}}</div>
                    <div class="font-size-primary py-1">{{(selectedStore$ | async)?.description}}</div>
                    <div class="d-flex">
                        <div class="pt-1 pr-3 d-flex align-items-center open-time space-nowrap font-size-primary font-weight-bold"
                            (click)="onOpenTimeModal($event,'aboutUs')" style="cursor: pointer;"
                            *ngIf="selectedStore?.phoneNumber?.length > 8 || selectedStore?.settings?.STORE_WEBSITE_URL || selectedStore?.settings?.DISPLAY_ADDRESS || isSocialMediaHandlePresent() || isReviewMediaHandlePresent()">
                            <i class="material-icons pr-2 theme-light">info_outline</i>
                            <span>{{'public.store.catalog.aboutUs' | translate}}</span>
                        </div>
                        <div *ngIf="openTimeSchedule"
                            class="pt-1 d-flex align-items-center open-time space-nowrap font-size-primary font-weight-bold"
                            (click)="onOpenTimeModal($event,'openTimes')" style="cursor: pointer;">
                            <i class="far fa-clock pr-2 theme-light"></i>
                            <span>{{'public.global.opentimelist' | translate}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <app-store-catalog-language-selector
                (isLoadingStatus)="isLoadingEmitter($event)"></app-store-catalog-language-selector>
        </div>
    </ng-template>
</div>
